export const CRLF = "\r\n";
export const RESET = "\x1b[0m";

const CODES: Record<string, number> = {
  bold: 1,
  black: 30, red: 31, green: 32, yellow: 33, blue: 34, magenta: 35, cyan: 36, white: 37,
  "bright-black": 90, "bright-red": 91, "bright-green": 92, "bright-yellow": 93,
  "bright-blue": 94, "bright-magenta": 95, "bright-cyan": 96, "bright-white": 97,
  "bg-black": 40, "bg-red": 41, "bg-green": 42, "bg-yellow": 43,
  "bg-blue": 44, "bg-magenta": 45, "bg-cyan": 46, "bg-white": 47,
};

/** "bright-yellow bg-blue" -> an SGR escape that resets first, then applies each code. */
export function sgr(spec: string): string {
  const codes = spec.split(/\s+/).filter(Boolean).map((name) => {
    const code = CODES[name];
    if (code === undefined) throw new Error(`Unknown color "${name}"`);
    return code;
  });
  return `\x1b[0;${codes.join(";")}m`;
}

/**
 * Expands {token}s in trusted skin text: palette names become colors, {reset}
 * resets, and anything in vars is substituted. Never pass member-written text here.
 */
export function paint(
  text: string,
  palette: Record<string, string>,
  vars: Record<string, string | number> = {},
): string {
  return text.replace(/\{([a-z][a-z0-9-]*)\}/gi, (match, key: string) => {
    if (key === "reset") return RESET;
    if (key in palette) return sgr(palette[key]);
    if (key in vars) return String(vars[key]);
    return match;
  });
}
